module.exports = __webpack_public_path__ + "img/adcetris-logo.6206ecd1.png";